import { render, staticRenderFns } from "./AddProperty.vue?vue&type=template&id=256b8c24&scoped=true&"
import script from "./AddProperty.vue?vue&type=script&lang=js&"
export * from "./AddProperty.vue?vue&type=script&lang=js&"
import style0 from "./AddProperty.vue?vue&type=style&index=0&id=256b8c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b8c24",
  null
  
)

export default component.exports